import './SeoInformation.scss';

export default () => {
  const node = document.querySelector('#seo-information');
  if (!node) return;
  node.querySelector('[data-expand]')?.addEventListener('click', (event) => {
    event.preventDefault();
    node.classList.toggle('-active');
  });
};
